import styled from 'styled-components'

export const VideoContainer = styled.div`
	padding: 3rem 1rem;
	width: 100%;
	height: auto;
`
